import { BaseDto } from "@/shared/dtos/base-dto";

export class solicitudes_eventos_audit extends BaseDto {
  public id_solicitud: number = 0;
  public tipo_evento: string = "";
  public descripcion: string = "";
  public datos_json: string = "";
  public actor_tipo: string = "sistema";
  public actor_id: number | null = null;
  public ip: string = "";
  public user_agent: string = "";
  public created_at: Date | null = null;

  constructor(data?: any) {
    super();
    if (!data) return;
    this.copy(data);
    if (data.created_at) this.created_at = new Date(data.created_at);
  }
}
